class ComponentTabs extends Theme.Component {
  selectTab(detail, element) {
    const key = element.dataset.key;

    this.querySelectorAll('[data-tab]').forEach((tab) => {
      const isActive = tab.dataset.key === key;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
    });

    this.querySelectorAll('[data-panel]').forEach((panel) => {
      panel.classList.toggle('is-active', panel.dataset.key === key);
    });
  }
}

customElements.define('component-tabs', ComponentTabs);
